// Splide init
function mmInitSplide() {
  const id = ".mm-dc-slider";
  const splideElem = document.querySelector(id);

  if (splideElem) {
    new Splide(splideElem, {
      type: "splide",
      arrows: true,
      pagination: false,
      autoplay: false,
      interval: 4000,
      rewind: true,
      gap: 4,
      perPage: 2,
      padding: {
        left: 20,
      },
    }).mount();
  }
}

document.addEventListener(
  "DOMContentLoaded",
  () => {
    mmInitSplide();
  },
  { once: true }
);

// Debounce
// https://redd.one/blog/debounce-vs-throttle
// If function is called several times in {duration},
// wait for a pause longer than {duration} to actually trigger it.
// eg, wait 500 milliseconds after last call to actually call doSomething():
// debounce(function () {
//    doSomething();
//  }, 500)
function debounce(func, duration) {
  let timeout;
  return function (...args) {
    const effect = () => {
      timeout = null;
      return func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(effect, duration);
  };
}

function mmCartSectionElement() {
  return document.getElementById("shopify-section-mm-cart");
}

function mmCartProductsContainerElement() {
  return mmCartSectionElement().querySelector(".mm-dc-products-container");
}

function mmCartItem(productVariantId) {
  return mmCartProductsContainerElement().querySelector(`[data-cart-item-id="${productVariantId}"]`);
}

function mmCartItemQuantityEl(productVariantId) {
  const itemEl = mmCartItem(productVariantId);

  return itemEl.querySelector("[data-item-quantity]");
}

function mmGetCartItemQuantity(productVariantId) {
  const quantityEl = mmCartItemQuantityEl(productVariantId);

  return Number.parseInt(quantityEl.dataset.itemQuantity);
}

function mmSetCartItemQuantity(productVariantId, newQuantity) {
  if (newQuantity >= 0) {
    const quantityEl = mmCartItemQuantityEl(productVariantId);

    quantityEl.dataset.itemQuantity = newQuantity;
    quantityEl.innerText = newQuantity;
  }
}

function mmCartHTMLFromData(data) {
  const el = document.createElement("DIV");
  el.innerHTML = data.sections["mm-cart"];

  return el;
}

function extractItemsFromCartHTML(data) {
  const el = mmCartHTMLFromData(data);
  return el.querySelector(".mm-dc-products-container");
}

function insertCartProductsFromResponse(data) {
  const itemsContainer = extractItemsFromCartHTML(data);
  mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;

  return data;
}

function extractTotalPriceFromCartHTML(data) {
  const cartEl = mmCartHTMLFromData(data); // ¡ fait atención gringo !
  return cartEl.querySelector("[data-cart-total-price]");
}

function insertInsertTotalPriceFromResponse(data) {
  const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
  const currentTotalPriceEl = mmCartSectionElement().querySelector("[data-cart-total-price]");
  const currentTotalPriceEl2 = mmCartSectionElement().querySelector("[data-cart-total-price-2]");
  currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;
  currentTotalPriceEl2.innerHTML = newTotalPriceEl.innerHTML;

  return data;
}

function mmAPIRequest(method, path, body) {
  document.querySelector(".mm-dc-products").classList.add("mm-inactive");
  return fetch(window.Shopify.routes.root + path, {
    method: method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((data) => {
      document.querySelector(".mm-dc-products").classList.remove("mm-inactive");
      if (mmCartSectionElement().querySelector(".mm-dc-free-item-progress--inner")) {
        const freeItemsProgress = mmCartSectionElement().querySelector(".mm-dc-free-item-progress--inner");

        var pallier_1 = document.getElementById("mmCartProgressBarValue").value;
        if (document.getElementById("mmCartProgressBarValue_2") != null) {
          var pallier_2 = document.getElementById("mmCartProgressBarValue_2").value;
        }
        if (data.total_price < pallier_1) {
          var newWidth = (data.total_price / document.getElementById("mmCartProgressBarValue").value) * 100 * 0.4;
        } else if (pallier_2 != null && (data.total_price + data.total_discount) < pallier_2) {
          var newWidth = ((data.total_price - document.getElementById("mmCartProgressBarValue").value) / (document.getElementById("mmCartProgressBarValue_2").value - document.getElementById("mmCartProgressBarValue").value)) * 40 + 40;
        } else {
          var newWidth = (data.total_price / document.getElementById("mmCartProgressBarValue").value) * 100;
        }
        freeItemsProgress.style.width = `${newWidth}%`;

        if (data.total_price >= document.getElementById("mmCartDeliveryValue").value) {
          document.querySelector(".mm-dc-free-delivery-text_succes").style.display = "flex";
          document.querySelector(".mm-dc-free-delivery-text_not_yet").style.display = "none";
        } else {
          document.querySelector(".mm-dc-free-delivery-text_succes").style.display = "none";
          document.querySelector(".mm-dc-free-delivery-text_not_yet").style.display = "flex";
        }
        const montantRestant = document.querySelector(".mm-dc-free-delivery-text_not_yet span");
        if (montantRestant) {
          montantRestant.innerText = ((document.getElementById("mmCartDeliveryValue").value - data.total_price) / 100).toFixed(2);
        }
        mmAddOrRemoveFreeProducts(data);
        updateCartCount(data.item_count != null ? data.item_count : 0);

      }
      return data;
    })
    .then((data) => {
      if (data.status && data.status > 400) {
        throw data;
      } else {
        return data;
      }
    });
}

// récupérer le panier
function mmGetCart() {
  mmAPIRequest("GET", "cart.js").then(console.log);
}

// Ouvrir le panier
function mmOpenCart() {
  document.querySelector(".mm-drawer-cart-filter").classList.add("mm-dc-is-open");
  document.querySelector("html").classList.add("stop-scrolling");
}

// Fermer le panier
function mmCloseCart() {
  document.querySelector(".mm-drawer-cart-filter").classList.remove("mm-dc-is-open");
  document.querySelector("html").classList.remove("stop-scrolling");
}

// Re-render cart inner HTML from response
function refreshCartFromData(data) {
  const newCartEl = document.createElement("DIV");
  newCartEl.innerHTML = data.sections["mm-cart"];
  const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-filter");
  innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-filter").innerHTML;
  updateCartCount(newCartEl.querySelector("[data-cart-count]").dataset.cartCount);
  mmInitSplide();
}

// Ajouter un item au panier
function mmAddProductToCart(productId, { quantity = 1, openCart = true }, button) {

  var data = { quantity: quantity, id: productId };

  try {
  if (typeof button !== 'undefined') {
    var form = button.closest('form');
    var sellingPlan = form.querySelector('[name="selling_plan"]');

    if (typeof sellingPlan !== 'undefined') {
      var sellingPlanValue = sellingPlan.value;
      data.selling_plan = sellingPlanValue;
    }
  }
  } catch(e) {
    console.error(e);
  }
  
  mmAPIRequest("POST", "cart/add.js", {
    items: [data],
    sections: "mm-cart",
  })
    .then(refreshCartFromData)
    .then((data) => {
      if (openCart) {
        setTimeout(mmOpenCart);
      }
    })
    .catch((error) => {
      mmCartProductsContainerElement().innerHTML = `
      Oups, il y a eu une erreur, essayez de recharger la page !
      `;
      mmOpenCart();
      console.log(error);
    });
}

// Ajouter produits complementaires
function addComplementaryProductsToCart(productId, complementaryProductId) {
  mmAPIRequest("POST", "cart/add.js", {
    items: [
      { quantity: 1, id: productId },
      { quantity: 1, id: complementaryProductId }
    ],
    sections: "mm-cart",
  })
    .then(refreshCartFromData)
    .then((data) => {
      setTimeout(mmOpenCart);
    })
    .catch((error) => {
      mmCartProductsContainerElement().innerHTML = `
      Oups, il y a eu une erreur, essayez de recharger la page !
      `;
      mmOpenCart();
      console.log(error);
    });
}

function mmIncreaseProductQuantity(productVariantId) {
  const quantity = mmGetCartItemQuantity(productVariantId);
  const newQuantity = quantity + 1;
  mmSetCartItemQuantity(productVariantId, newQuantity);

  mmDebouncedPushNewQuantity(productVariantId);
}

function mmDecreaseProductQuantity(productVariantId) {
  const quantity = mmGetCartItemQuantity(productVariantId);
  const newQuantity = quantity - 1;
  mmSetCartItemQuantity(productVariantId, newQuantity);

  mmDebouncedPushNewQuantity(productVariantId);
}

function mmPushNewQuantity(productVariantId) {
  const quantity = mmGetCartItemQuantity(productVariantId);

  mmAPIRequest("POST", "cart/change.js", {
    id: productVariantId.toString(),
    quantity: quantity,
    sections: "mm-cart",
  })
    .then(insertCartProductsFromResponse)
    .then(insertInsertTotalPriceFromResponse)
    .then(mmAddOrRemoveFreeProducts);
}

const mmDebouncedPushNewQuantity = debounce(function (productVariantId) {
  mmPushNewQuantity(productVariantId);
}, 300);

function mmRemoveProductQuantity(productVariantId) {
  const quantity = mmGetCartItemQuantity(productVariantId);
  const newQuantity = 0;
  mmSetCartItemQuantity(productVariantId, newQuantity);

  mmDebouncedPushNewQuantity(productVariantId);
}

function mmAddOrRemoveFreeProducts(data) {
  if (data.sections["mm-cart"]) {
    const el = mmCartHTMLFromData(data);
    const freeProductEls = el.querySelector("[data-free-products]");
    let freeProductCounts = 0;
    // creates an object like { 44058675: 1, 44058001: 0 }
    // where key is free product id and value, its quantity
    const productsParams = Array.from(freeProductEls.children).reduce((param, freeProductEl) => {

      const productId = freeProductEl.dataset.productId;
      const isFree = freeProductEl.dataset.freeProduct == "true";
      let isRefused = false
      if (isFree && sessionStorage.getItem('productId') == 'true') {
        isRefused = true;
      }
      const itemEl = mmCartItem(productId);

      if (isFree && !isRefused) {
        freeProductCounts += 1;
      }
      if (itemEl && isFree) {
        // do nothing, item is already added
      } else if ((itemEl && !isFree)) {
        // item is present but should be removed
        param[productId] = 0;
      } else if (!itemEl && isFree && !isRefused) {
        // item is absent but should be added
        param[productId] = 1;
      }
      return param;
    }, {});

    // Add or remove free products only if needed
    if (Object.keys(productsParams).length > 0) {
      mmAPIRequest("POST", "cart/update.js", {
        updates: productsParams,
        sections: "mm-cart",
      })
        .then(insertCartProductsFromResponse)
        .then(insertInsertTotalPriceFromResponse);
    }
  }
  return data;
}

function mmToggleFreeProduct(value) {
  sessionStorage.setItem('productId', value);
}

// PROGRESS BAR
function mmProgressBar() { }

function updateCartCount(value) {
  var cartCountValue = document.querySelector(".cart-count-bubble span");
  cartCountValue.innerText = value;
}
